import { listRecentConsultations } from '../../api/clinical'
import { useFetch } from '../../hooks/useFetch'
import { cn } from '@/lib/utils'
import { thClass, tbodyHoverClass } from '@/lib/tableStyles'
import { DashboardWidgetCard } from './DashboardWidgetCard'
import { ConsultationRow } from './ConsultationRow'

/** Renders nothing while loading or once loaded with zero open consultations —
 * matches the original dashboard's behaviour of only showing this section when
 * there's something to act on. */
export function OpenConsultationsWidget() {
  const { data } = useFetch(() => listRecentConsultations(50, 'open'), [])
  const open = data ?? []

  if (open.length === 0) return null

  return (
    <DashboardWidgetCard title="Open Consultations">
      <table className="w-full border-collapse text-[0.875rem]">
        <thead>
          <tr>
            <th className={thClass}>Reason</th>
            <th className={thClass}>Date</th>
            <th className={thClass}>Practice</th>
            <th className={thClass}>Vet</th>
            <th className={thClass}>Status</th>
            <th className={cn(thClass, 'text-right')}></th>
          </tr>
        </thead>
        <tbody className={tbodyHoverClass}>
          {open.map(c => <ConsultationRow key={c.id} c={c} />)}
        </tbody>
      </table>
    </DashboardWidgetCard>
  )
}
